export enum WebhookEventsEnum {
    ORDER_TRIP_CREATED = 'order.trip_created',
    ORDER_TRIP_STARTED = 'order.trip_started',
    ORDER_ARRIVING = 'order.arriving',
    ORDER_CERTIFIED = 'order.certified',
    ORDER_FAILED = 'order.failed',
    TRIP_CREATED = 'trip.trip_created',
    TRIP_UPDATED = 'trip.trip_updated',
}
